/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '../../mutations.constants';
import licenseState from "./state";

export const state = licenseState;
const mutations = {
  [storeMutations.licenseManagerMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.licenseManagers = res.data;
    }
  },
  [storeMutations.roleListMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.roleList = res.data;
    }
  },
  
  
  };
export default { ...mutations };
